import ApplicationAdapter from './application';

export default class EventAdapter extends ApplicationAdapter {
  pathForType() {
    return super.pathForType('eventName');
  }
}
